import React from 'react';

const Home = () => {
  return (
    <section className='hero is-fullheight-with-navbar is-primary'>
      <div className='hero-body'>
        <div className='home-container'>
          <h3 className='title has-text-centered '>
            Welcome to Doggypedia, the encyclopaedia for dogs. Here at
            Doggypedia we aim to make it easy and accessible for you to fully
            research different dog breeds so you will feel comfortable when
            choosing your next furry, four legged companion!
          </h3>
        </div>
      </div>
    </section>
  );
};

export default Home;
